import { render, staticRenderFns } from "./processusDossier.vue?vue&type=template&id=7c4a1967&scoped=true"
import script from "./processusDossier.vue?vue&type=script&lang=js"
export * from "./processusDossier.vue?vue&type=script&lang=js"
import style0 from "./processusDossier.vue?vue&type=style&index=0&id=7c4a1967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a1967",
  null
  
)

export default component.exports